import React from 'react';

export default function SectionWrapper({ children, className = '', id = '' }) {
  return (
    <div className={className} {...(id ? { id } : {})}>
      {children}
    </div>
  );
}
